export default __webpack_public_path__ + "static/media/kounta.cc60ced9.png";